<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">客户管理</h4>
          </template>
		  
		  <div class="search">
			  <input type="text" class="form-control col-2" placeholder="客户名称" aria-label="客户名称" aria-describedby="basic-addon1" v-model="searchData.keyWord">
		      <button type="button" class="btn btn-primary" @click="search()">搜索</button>
			  <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" @click="newCompany()">新增客户</button>
			  <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" @click="newOrder()">新增订单</button>
		      <button type="button" class="btn btn-primary"  @click="del()">删除</button>
		  </div>
		  
          <div class="table-responsive text-left">			  
				  <el-table class="table" 
				  :data="companys" width="100%"  
				  @current-change="handleCurrenChange"
				  highlight-current-row
				  tooltip-effect="dark"
				  >
				  <el-table-column prop="name" label="名称"></el-table-column>
				  <el-table-column prop="yewuCode" label="业务员编码" width="100"></el-table-column>
				  <el-table-column prop="customerCode" label="客户编码" width="100"></el-table-column>
				  <el-table-column prop="tel" label="电话" width="150"></el-table-column>
				  <el-table-column prop="web" label="网址" width="150"></el-table-column>
				  <el-table-column prop="dateEntered" label="登记日期" width="200"></el-table-column>

    		      </el-table>
          </div>
		  
		  <nav aria-label="Page navigation example" style="margin-top:30px;">
		    <ul class="pagination justify-content-center">
		      <li class="page-item" id="previous" :class="{'disabled':searchData.pageNum==1}">
		        <a class="page-link" href="#" @click="previous()">Previous</a>
		      </li>
		  			  <li class='page-item' style="margin-left: 5px;margin-right: 5px;"> page {{searchData.pageNum}} of {{pages}} </li>			  
		      <li class="page-item" id="next" :class="{'disabled':searchData.pageNum==pages}">
		        <a class="page-link" href="#" @click="next()">Next</a>
		      </li>	
		  			  <li class="pageSize" style="margin-left: 5px;"> 每页：<span><a href="#" @click="searchData.pageSize=10;searchData.pageNum=1;search();">10</a></span><span><a href="#" @click="searchData.pageSize=50;searchData.pageNum=1;search();">50</a></span><span><a href="#"  @click="searchData.pageSize=100;searchData.pageNum=1;search();">100</a></span></li>
		  			</ul>
		  </nav>	
		  
        </card>
      </div>
    </div>

    <Modal :isVisible="showModal" @close="showModal = false">
		<template #header>
		    <div style="color:#000">
			添加新客户
			</div>
		</template>
				  
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="客户名称" aria-label="客户名称" v-model.trim="params.company.name">			
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-2" placeholder="国家" aria-label="国家" style="display:inline;
		margin-top:5px;margin-right:5px;text-align:left;" v-model.trim="params.company.country">
		<input type="text" class="form-control col-2" placeholder="城市" aria-label="城市" style="display:inline;
		margin-top:5px;" v-model="params.company.city">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-12" placeholder="地址" aria-label="地址" style="margin-top:5px;" v-model.trim="params.company.address">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="电话" aria-label="电话" style="margin-top:5px;" v-model.trim="params.company.tel">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="传真" aria-label="传真" style="margin-top:5px;" v-model.trim="params.company.fax">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="邮箱" aria-label="邮箱" style="margin-top:5px;" v-model.trim="params.company.email">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="网址" aria-label="网址" style="margin-top:5px;" v-model.trim="params.company.web">
		</div>
		
		<div class="row">
		<input type="text" class="form-control col-12" placeholder="主营业务" aria-label="主营业务" style="margin-top:5px;" v-model.trim="params.company.mainBusiness">
		</div>		
		
		<template #footer>
		  <span class="text-warning" style="padding:15px;">{{msg}}</span>
		  <button @click="clear()" class="btn btn-primary">重置</button>
		  <button @click="save()" class="btn btn-primary">保存</button>
		</template>		
    </Modal>	
	
	<Modal :isVisible="newOrderDiv" @close="newOrderDiv = false">
		<template #header>
		    <div style="color:#000">
			<span style="color:burlywood">{{addForm.companyName}} </span>添加订单
			</div>
		</template>
				  
		<div class="row">
			<el-form :model="addForm" :inline="true" :rules="rules" ref="addRuleForm">	
				<el-form-item
				  label="订单编码"
				  prop="orderNo"
				>
				  <el-input
				    v-model="addForm.orderNo"
				    auto-complete="off"
				    clearable
				  ></el-input>
				</el-form-item>
				
			    <el-form-item
			       label="合同编码"
			       prop="contractNo"
			     >
			      <el-input
			        v-model="addForm.contractNo"
			        auto-complete="off"
			         style="width: 60%"
			        clearable
			      ></el-input>
			     </el-form-item>
			
			     <el-form-item
			        label="物料编码"	
			        prop="materialNo"
			      >
			       <el-input
			         v-model="addForm.materialNo"
			         auto-complete="off"
			          style="width: 60%"
			         clearable
			       ></el-input>
			      </el-form-item>
			</el-form>
		</div>		
		
		<template #footer>
		  <span class="text-warning" style="padding:15px;">{{msg}}</span>
		  <button @click="clearNewOrder()" class="btn btn-primary">重置</button>
		  <button @click="saveNewOrder()" class="btn btn-primary">保存</button>
		</template>		
	</Modal>
	
  </div>
</template>

<script>
import { Card } from "@/components/index";
import BaseTable from "@/components/BaseTable";
import Modal from "@/pages/Layout/Modal.vue";
import { Checkbox } from "element-ui";
import { Message,MessageBox} from "element-ui";
export default {
  props:['msg'],
  components: {
    Card,
    BaseTable,
	Modal,
	Checkbox
  },
  data() {
    return {
	  showModal:false,
	  params:{
		  company:{
		  name:"",
		  country:"",
		  city:"",
		  address:"",
		  tel:"",
		  fax:"",
		  email:"",
		  web:"",
		  mainBusiness:"",
	      },
	  },
	  searchData:{
		  keyWord:"",
		  pageSize:10,
		  pageNum:1, 
	  },	  
	  delData:{
		  companyId:"",
		  force:false
	  },
	  pages:1,
	  companys:[],
	  currentRow:null,
	  newOrderDiv:false,
	  addForm:{
		  contractNo:"",
		  materialNo:"",
		  orderNo:"",
		  companyId:"",
		  companyName:""
	  },
	  rules:{orderNo: [{ required: true, message: "订单编码不能为空", trigger: "blur" }]},
    };
  },
  created() {
	  this.search();
  },
  methods:{
    async save(){
		let res =await this.$axios.post(this.$serverUrl+"/company/add",this.params.company);		
		if(res.data.state==200){
			this.clear();
			this.showModal=false;
			this.search();
		}else{
			this.msg=res.data.msg;
		}
    },
	async search(){
		let res =await this.$axios.post(this.$serverUrl+"/company/getAllCompany",this.searchData).then(Response=>{
			this.companys=Response.data.data.list
			this.pages=Response.data.data.pages;
		});		
	},
	newCompany(){
		this.params.company.name="";
		this.params.company.country="";
		this.params.company.city="";
		this.params.company.address="";
		this.params.company.tel="";
		this.params.company.fax="";
		this.params.company.email="";
		this.params.company.web="";
		this.params.company.mainBusiness="";
		this.showModal=true;
		this.msg="";
	},
	newOrder(){
		if(this.currentRow!=null){
		    this.newOrderDiv=true;
			this.addForm.companyName=this.currentRow.name;
			this.addForm.companyId=this.currentRow.companyId;
		}else{
			Message(
			{
			 type: "error",
			 message: "未选择公司。",
			 offset:window.screen.height/2-100
			});
		}
	},
	clear(){
		this.params.company.name="";
		this.params.company.country="";
		this.params.company.city="";
		this.params.company.address="";
		this.params.company.tel="";
		this.params.company.fax="";
		this.params.company.email="";
		this.params.company.web="";
		this.params.company.mainBusiness="";
		this.msg="";
	},
	clearNewOrder(){
		this.addForm.orderNo="";
		this.addForm.contractNo="";
		this.addForm.materialNo="";
	},
	handleSelectionChange(val) {
		this.delData.multipleSelection = val;		
	},
	handleCurrenChange(val){
		this.delData.companyId=val.companyId;
		this.currentRow=val;
	},
	previous(){
		this.searchData.pageNum=this.searchData.pageNum-1;
		this.search();
	},
	next(){
		this.searchData.pageNum=this.searchData.pageNum+1;
		this.search();
	},
	del(){
		if(this.currentRow!=null){
			MessageBox.confirm("确定要删除 “"+this.currentRow.name+"” ?","确认",{
			  distinguishCancelAndClose: true,
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning',
			  offset:window.screen.height/2-100
			}).then(()=>{
                this.$axios.post(this.$serverUrl+"/company/del",this.delData).then(
					response => {			
					  if(response.data.state==200){
						this.search();
					  }else{
						Message(
						{
						 type: "error",
						 message: response.data.msg,
						 offset:window.screen.height/2-100
						});
					  }
					}
				).catch(			
					error=>{
						if(error.response.data.state===500){
						this.wait=false;
						Message(
						{
						 type: "error",
						 message: "系统出错了。",
						 offset:window.screen.height/2-100
						});
						}
				})
			});
		}else{
			Message(
			{
			 type: "error",
			 message: "未选择公司。",
			 offset:window.screen.height/2-100
			});
		}		
	},
	saveNewOrder(){
		this.$axios.post(this.$serverUrl+"/order/add",this.addForm).then(
			response => {			
			  if(response.data.state==200){
				this.clearNewOrder();
				this.newOrderDiv=false;
				Message(
				{
				 type: "success",
				 message: response.data.msg,
				 offset:window.screen.height/2-100
				});
			  }else{
				Message(
				{
				 type: "error",
				 message: response.data.msg,
				 offset:window.screen.height/2-100
				});
			  }
			}
		).catch(			
			error=>{
				if(error.response.data.state===500){
				Message(
				{
				 type: "error",
				 message: "系统出错了。",
				 offset:window.screen.height/2-100
				});
				}
		})
	}
  }
};
</script>
<style>
	modal input{
		margin-top:5px;
		text-align:left;
	}
	
	.search input{
		display:inline;
		margin-right:5px;
	}
	.el-message-box__message p{
		color:#000;
	}
</style>
